import React, { useState } from "react";
import Modal from "react-modal";
import Styles from "./dates.module.css";
import ReactLoading from "react-loading";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Services } from "Services";
import Swal from "sweetalert";
import { Error } from "Util/Toast";

function Add({ completemodal, setModal, data, TutorData, TutorID }) {
    const [loading, setLoading] = useState(false);

    const token = { Authorization: `token ${localStorage.getItem("token")}` };
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        setError,
        clearErrors,
        unregister,
        setValue,
        watch,
    } = useForm();
    function getDatesBetween(fromDate, toDate) {
        const datesArray = [];
        const currentDate = new Date(fromDate);
        const endDate = new Date(toDate);

        while (currentDate <= endDate) {
            datesArray.push(currentDate.toISOString().split("T")[0]);
            currentDate.setDate(currentDate.getDate() + 1);
        }

        return datesArray;
    }
    async function onSubmit(formData) {
        setLoading(true);
        let body = {
            CancelReason: "Long Leave",
            Comments: "",
            CancelType: "Long_Leave",
            NoOfDays: getDatesBetween(formData.FromDate, formData.ToDate)
                .length,
            Cancelled_Dates: [],
            JoinedDate: TutorData?.JoinedDate,
            ScheduleClassIDs: [],
            TutorID: TutorID,
            ClassesCount: 0,
            FromDate: formData?.FromDate,
            ToDate: formData?.ToDate,
            Dates: getDatesBetween(formData.FromDate, formData.ToDate),
        };
        try {
            const Response = await Services.bulk_cancel_tutor(
                "POST",
                JSON.stringify(body),
                token
            );

            if (Response.Status === 1) {
                data();
                reset({ FromDate: "", ToDate: "" });
                Swal({
                    title: "Dates Updated",

                    icon: "success",
                });
            } else {
                Error(Response?.Message);
            }
        } catch (err) {
            console.log(err);
            // setModal(false);
            Error("something went wrong please try again");
        } finally {
            setLoading(false);
        }
    }

    return (
        <div>
            <Modal
                isOpen={completemodal}
                contentLabel="Modal"
                onRequestClose={() => {
                    setModal(false);
                    reset();
                    clearErrors();
                }}
                className={Styles["modal"]}
                overlayClassName={Styles["overlay"]}>
                <div className={Styles["wrapper"]}>
                    <header>
                        <h3>Long Leave Dates</h3>
                    </header>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className={Styles["form-control"]}>
                            <label htmlFor="Reason"> From Date</label>
                            <input
                                type="date"
                                {...register("FromDate", {
                                    required: "This field is required",
                                })}
                            />
                            {errors.FromDate && (
                                <span style={{ color: "red" }}>
                                    {errors.FromDate.message}
                                </span>
                            )}
                        </div>
                        <div className={Styles["form-control"]}>
                            <label htmlFor="Reason">To Date</label>
                            <input
                                type="date"
                                {...register("ToDate", {
                                    required: "This field is required",
                                })}
                            />
                            {errors.ToDate && (
                                <span style={{ color: "red" }}>
                                    {errors.ToDate.message}
                                </span>
                            )}
                        </div>

                        {loading ? (
                            <div
                                style={{
                                    justifySelf: "center",
                                    marginTop: "1rem",
                                }}>
                                {" "}
                                <ReactLoading
                                    color="green"
                                    type="spokes"
                                    height={30}
                                    width={30}
                                />
                            </div>
                        ) : (
                            <div className={Styles["Control-btns"]}>
                                <button type="submit">Update</button>
                                <button
                                    type="button"
                                    onClick={() => {
                                        setModal(false);
                                        clearErrors();
                                        reset();
                                    }}>
                                    close
                                </button>
                            </div>
                        )}
                    </form>
                </div>
            </Modal>
        </div>
    );
}

export default Add;
